import { APIStatus, CheckStatus, LanguageConfig, SESSION_KEYS } from '../config/CustomEnums';
import { downloadZipFiles } from '../containers/merchants/stores/QRCodeDownloadUtil';
import { StoreErrorHandleFields } from '../containers/merchants/stores/StoreErrorHandleFields';
import {
  createOrUpdateStore,
  deleteStores,
  getAllCouponStores,
  getDistricts,
  getDownloadStoreCodesZip,
  getOneStore,
  getPagedSimplyStoresWithBrand,
  getPagedStores,
  getPureStores,
  getStores,
  getStoresOfBrand,
} from '../services/StoreAPIHelper';
import { convertCursorToNumber, convertNumberToCursor, convertPKToId, createAction, getDisplayLastModifiedBy, getFileNameFromUrl, getObjectFromSessionStorage, removeElementFromArray, removeFromSessionStorage, removeUndefinedFieldFromDict, saveToSessionStorage } from '../utils';
import { createModel } from './BaseModel';
import { apiWithResponseHandle, loading } from './LoadingUtil';

import { lowercaseFirstLetter } from 'utils/StringUtil';
import {
  getDetailPageDisplayLastModifiedDate,
  getListDisplayLastModifiedDate,
} from 'utils/TimeFormatUtil';

const storeSessionKey = SESSION_KEYS.STORE_SESSION_KEY;

export const saveDataToSessionStorage = (data) => {
  saveToSessionStorage(storeSessionKey, data);
};

export const removeDataFromSessionStorage = () => {
  removeFromSessionStorage(storeSessionKey);
};

function* brandApplicableStore(payload, select, put) {
  function* loadResult(data = {}, prePayload = {}) {
    const endCursor = data.endCursor || 0;
    const differCursor = endCursor - data.startCursor || 0;
    const pagedStoreList = data.stores;
    const newList = [];
    let tempKey = '';
    let finalKey = '';
    let oldTempList = [];
    console.log('prePayload:', prePayload);
    const notBrandRelate = payload.notBrandRelate;
    if (notBrandRelate) {
      oldTempList = yield select(
        (state) => state.storeModel.tempAppliableStoreList || [],
      );
      tempKey = 'tempAppliableStoreList';
      finalKey = 'appliableStoreList';
    } else {
      oldTempList = yield select(
        (state) => state.storeModel.tempBrandStoreList || [],
      );
      tempKey = 'tempBrandStoreList';
      finalKey = 'brandStoreList';
    }
    console.log('@72', oldTempList, pagedStoreList);
    const combineList = [...oldTempList, ...pagedStoreList];
    combineList.forEach((item) => {
      const exist = newList.some((newItem) => newItem.pk === item.pk);
      if (!exist) {
        newList.push(item);
      }
    });

    yield put({
      type: 'updateState',
      payload: {
        [tempKey]: newList,
      },
    });
    console.log('endCursor:', endCursor);
    if (differCursor >= 99) {
      const currentPage = (endCursor + 1) / 100 + 1;
      yield put({
        type: notBrandRelate ? 'getAppliableStores' : 'getBrandStores',
        payload: { ...prePayload, page: currentPage },
      });
      return;
    }
    yield put({
      type: 'updateState',
      payload: {
        [finalKey]: newList,
        [tempKey]: [],
      },
    });
    if (!notBrandRelate) {
      yield put({
        type: 'updateState',
        payload: {
          allListLoading: false,
        },
      });
    }
  }

  const page = payload.page || 1;
  const pageCursor = payload.page
    ? convertNumberToCursor((page - 1) * 100 - 1)
    : '';

  function* onSuccess(data) {
    const pageInfo = data?.stores?.pageInfo;
    const storeList = data?.stores?.edges.map((item) =>
      parseStore(item.node, payload?.minimalist, payload?.displayNameWithType),
    );
    const startCursor = convertCursorToNumber(pageInfo.startCursor);
    const endCursor = convertCursorToNumber(pageInfo.endCursor);
    yield loadResult(
      {
        stores: storeList,
        startCursor: startCursor,
        endCursor: endCursor,
      },
      payload,
    );
  }

  function* onError(data) {
    console.log('onErrordata:', data);
    yield loadResult({
      stores: [],
      startCursor: 0,
      endCursor: 0,
    });
  }
  console.log('@143', payload);
  const serviceArgs = [
    getPagedStores,
    pageCursor,
    { ...payload, isSelectorLoad: true, active: "true" },
  ];
  yield loading(serviceArgs, onSuccess, onError, onError);
}

const getTranslations = (data) => {
  const translationList = data.translations?.edges || [];
  const translation = {};
  translationList.forEach((item) => {
    const language = item.node.language;
    translation[language] = {
      ...item.node,
      name: item.node.name,
    };
  });
  translation[LanguageConfig.english] = {
    name: data.name,
    address: data.address,
    description: data.description,
    pk: data.pk,
  };
  return translation;
};

const postTranslations = (data, isOnlineStore = false) => {
  if (!data) {
    return [];
  }
  const languageList = Object.keys(data).filter(
    (language) => language !== LanguageConfig.english,
  );
  const translations = languageList.map((language) => {
    const newData = isOnlineStore
      ? {
          language,
          name: data[language].name,
        }
      : {
          language,
          name: data[language].name,
          address: data[language].address,
          description: data[language].description,
        };
    const id = data[language].pk;
    if (id) {
      newData.id = id;
    }
    return newData;
  });
  return translations;
};

const mergeOldData = (origin, old) => {
  const translationLang = Object.keys(origin?.storeTranslations || {}) || [];
  const storeTranslations = {};
  translationLang.forEach((translation) => {
    storeTranslations[translation] = {
      ...old?.storeTranslations?.[translation],
      ...origin?.storeTranslations?.[translation],
    };
    if (!origin.storePK) {
      delete storeTranslations[translation].pk;
    }
  });
  return {
    ...origin,
    storeTranslations: storeTranslations,
  };
};

const postData = (origin, old) => {
  const name =
    origin.storeTranslations?.[LanguageConfig.english]?.name || origin.name;
  if (!name) {
    return {
      ...origin,
    };
  }
  const data = mergeOldData(origin, old);
  let newData = {};
  if (data?.isOnlineStore) {
    newData = {
      name: name,
      isOnlineStore: data.isOnlineStore,
      visibleInFrontEnd:
        data.visibleInFrontEnd === undefined ? true : data.visibleInFrontEnd,
      active: data.active === undefined ? true : data.active,
      displayPriority: null,
      photo: null,
      district: null,
      address: null,
      phoneNumberCountryCode: null,
      phoneNumberSubscriberNumber: null,
      emailAddress: null,
      description: null,
      subcategories: [],
      latitude: null,
      longitude: null,
      staffCode: null,
      brand: data.brand?.pk,
      mall: data.mall?.pk,
      translations: postTranslations(data.storeTranslations, true),
      thirdPartyStoreCode: data.thirdPartyStoreCode,
    };
  } else {
    let photo = null;
    console.log('data.coverPhoto?.value', data.coverPhoto?.value);
    console.log('data.coverPhoto', data.coverPhoto);
    if (
      data.coverPhoto?.value === data.photoUrl ||
      data.coverPhoto === data.photoUrl
    ) {
      console.log('data.coverPhoto same as photoUrl');
      photo = null;
    } else {
      photo = getFileNameFromUrl(data.coverPhoto?.value || data.coverPhoto);
    }
    newData = {
      name: name,
      isOnlineStore: false,
      visibleInFrontEnd:
        data.visibleInFrontEnd === undefined ? true : data.visibleInFrontEnd,
      active: data.active === undefined ? true : data.active,
      displayPriority: data.displayPriority,
      photo: photo,
      district: data.district?.value?.pk || null,
      address: data.storeTranslations[LanguageConfig.english]?.address,
      phoneNumberCountryCode: data.phoneNumberCountryCode?.value,
      phoneNumberSubscriberNumber: data.phoneNumberSubscriberNumber,
      emailAddress: data.emailAddress,
      description: data.storeTranslations[LanguageConfig.english]?.description,
      brand: data.brand?.pk,
      mall: data.mall?.pk,
      subcategories: data.selectedSubcategories?.map((item) => item.pk),
      latitude: data.latitude,
      longitude: data.longitude,
      staffCode: data.staffCode,
      translations: postTranslations(data.storeTranslations),
      thirdPartyStoreCode: data.thirdPartyStoreCode,
    };
  }
  if (data.pk) {
    newData.id = data.pk;
    if (old.brand) {
      delete newData.brand;
    }
  }
  return newData;
};

const parseStore = (store, minimalist, displayNameWithType = false) => {
  if (!store) {
    return {};
  }
  const extraName = store.visibleInFrontEnd ? '' : '(closed)';
  if (minimalist) {
    return {
      pk: store.pk,
      storePK: store.pk,
      storeName: store.name,
      displayStoreName: `${store.name}${extraName}`,
      name: displayNameWithType
        ? `[${store?.isOnlineStore ? 'Online' : 'Offline'}]${
            store.name
          }${extraName}`
        : `${store.name}${extraName}`,
    };
  }
  return {
    ...store,
    storeID: store.id,
    storePK: store.pk,
    storeName: store.name,
    displayStoreName: `${store.name}${extraName}`,
    storeAddress: store.address,
    storeTranslations: getTranslations(store),
    photo: store.photo || store.photoUrl,
    coverPhoto: store.photo || store.photoUrl,
    photoUrl: store.photoUrl,
    phoneNumber: store.phoneNumberCountryCode
      ? `${store.phoneNumberCountryCode}-${store.phoneNumberSubscriberNumber}`
      : '-',
    displayPhoneNumber: store.phoneNumberCountryCode
      ? `+${store.phoneNumberCountryCode}${store.phoneNumberSubscriberNumber}`
      : '-',
    displaySubcategory: store.subcategories?.edges
      .map((item) => item.node.name)
      .join(','),
    selectedSubcategories:
      store.subcategories?.edges.map((item) => item.node) || [],
    // displaySubcategory:
    //   'Western, Chinese, German, French, Hunan, Cantonese, Northeastern, Jiangsu and Zhejiang cuisine, Sichuan cuisine...',
    order: store.displayPriority,
    displayDistrict: store.district?.name,
    displayBrand: store.brand?.name,
    displayMall: store.mall?.name,
    district: store.district
      ? { label: store.district.name, value: store.district }
      : null,
    phoneNumberCountryCode: {
      label: store.phoneNumberCountryCode,
      value: store.phoneNumberCountryCode,
    },
    displayName: store.name,
    codeDisplayImage: store?.isOnlineStore ? null : store.codeDisplayImage,
    codeDownloadImage: store.codeDownloadImage,
    displayStoreType: store?.isOnlineStore ? 'Online' : 'Offline',
    displayVisibleInFrontEnd: store.visibleInFrontEnd ? 'Showing' : 'Hidden',
    listDisplayLastModifiedTime: getListDisplayLastModifiedDate(
      store?.lastModifiedDate,
    ),
    detailDisplayCreationDate: getDetailPageDisplayLastModifiedDate(
      store?.creationDate,
    ),
    detailDisplayLastModifiedDate: getDetailPageDisplayLastModifiedDate(
      store?.lastModifiedDate,
    ),
    displayLastModifiedBy: getDisplayLastModifiedBy(store),
    displayStatus: store.active ? 'Active' : 'Deactive',
    displayThirdPartySyncTime: getDetailPageDisplayLastModifiedDate(
      store?.thirdPartySyncTime,
    ),
  };
};

const parseListStore = (store) => {
  if (!store) {
    return {};
  }
  const extraName = store.visibleInFrontEnd ? '' : '(closed)';
  return {
    pk: store.pk,
    name: store.name,
    displayStoreType: store?.isOnlineStore ? 'Online' : 'Offline',
    coverPhoto: store.photo ? store.photo : store.photoUrl,
    order: store.displayPriority,
    displayBrand: store.brand?.name,
    displayMall: store.mall?.name,
    phoneNumber: store.phoneNumberCountryCode
      ? `${store.phoneNumberCountryCode}-${store.phoneNumberSubscriberNumber}`
      : '-',
    emailAddress: store.emailAddress,
    displaySubcategory: store.subcategories?.edges
      .map((item) => item.node.name)
      .join(','),
    displayVisibleInFrontEnd: store.visibleInFrontEnd ? 'Showing' : 'Hidden',
    listDisplayLastModifiedTime: getListDisplayLastModifiedDate(
      store?.lastModifiedDate,
    ),

    codeDisplayImage: store?.isOnlineStore ? null : store.codeDisplayImage,
    displayName: store.name,

    displayDistrict: store.district?.name,
    storeID: store.id,
    storePK: store.pk,
    storeName: store.name,
    displayStoreName: `${store.name}${extraName}`,
    storeAddress: store.address,
    displayPhoneNumber: store.phoneNumberCountryCode
      ? `+${store.phoneNumberCountryCode}${store.phoneNumberSubscriberNumber}`
      : '-',
    selectedSubcategories:
      store.subcategories?.edges.map((item) => item.node) || [],
    district: store.district
      ? { label: store.district.name, value: store.district }
      : null,
    phoneNumberCountryCode: {
      label: store.phoneNumberCountryCode,
      value: store.phoneNumberCountryCode,
    },
    codeDownloadImage: store.codeDownloadImage,
    detailDisplayCreationDate: getDetailPageDisplayLastModifiedDate(
      store?.creationDate,
    ),
    detailDisplayLastModifiedDate: getDetailPageDisplayLastModifiedDate(
      store?.lastModifiedDate,
    ),
    displayLastModifiedBy: getDisplayLastModifiedBy(store),
    couponStock: store?.couponStock,
    isOutOfStock: store?.couponStock === 0,
    displayStatus: store.active ? 'Active' : 'Deactive',
  };
};

const getInitState = () => {
  return {
    storeList: [],
    allListLoading: false,
    selectedAllListLoading: false,
    storeEditMode: false,
    tempBrandStoreList: [],
    tempAppliableStoreList: [],
    appliableStoreList: [],
    brandStoreList: [],
    listDisplayFields: [
      { displayName: 'ID', fieldName: 'pk', orderField: 'pk' },
      { displayName: 'Name', fieldName: 'name', orderField: 'name' },
      { displayName: 'Store type', fieldName: 'displayStoreType' },
      { displayName: 'Cover photo', fieldName: 'coverPhoto' },
      {
        displayName: 'Display order',
        fieldName: 'order',
        orderField: 'displayPriority',
      },
      { displayName: 'Brand', fieldName: 'displayBrand' },
      { displayName: 'Phone number', fieldName: 'phoneNumber' },
      { displayName: 'Email', fieldName: 'emailAddress' },
      { displayName: 'Subcategory', fieldName: 'displaySubcategory', lines: 5 },
      {
        displayName: 'Visible in front end',
        fieldName: 'displayVisibleInFrontEnd',
      },
      {
        displayName: 'Last modified time',
        fieldName: 'listDisplayLastModifiedTime',
      },
      {
        displayName: 'Status',
        fieldName: 'displayStatus',
      },
    ],
    codeListDisplayFields: [
      { displayName: 'ID', fieldName: 'pk' },
      { displayName: 'Cover Photo', fieldName: 'codeDisplayImage' },
      { displayName: 'Related Store', fieldName: 'displayName' },
    ],
    pagedStoreList: [],
    pageInfo: {
      startCursor: '',
      endCursor: '',
      hasNextPage: false,
      hasPreviousPage: false,
    },
    totalPage: 0,
    totalCount: 0,
    currentPage: 0,
    checkedList: [],
    oneStore: {},
    checked: CheckStatus.initOrNotChecked,
    errorFields: {},
    saved: APIStatus.none,
    formChanged: false,
    districtList: [],
    formHasSubmitted: false,
    hasUpdatedDefaultValues: false,
    currentLastCursor: '',
    couponStores: {},
  };
};

export default createModel({
  namespace: 'storeModel',
  state: getInitState(),
  params: {
    sessionKey: SESSION_KEYS.STORE_SESSION_KEY,
    listAPI: getPagedStores,
    parse: (data) => data?.stores?.edges?.map((item) => item.node),
    objectKey: 'storeList',
  },
  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    updateCouponStores(state, { payload }) {
      console.log('@@504: ', payload);
      const originalCouponStores = state.couponStores;
      const { removedStoreConditions } = payload;
      const newCouponStores = { ...originalCouponStores };
      if (removedStoreConditions) {
        if (removedStoreConditions.type === 'store') {
          newCouponStores.stores = newCouponStores.stores.filter(
            (store) => store.id !== removedStoreConditions.value,
          );
        } else if (removedStoreConditions.type === 'storeCategory') {
          newCouponStores.stores = newCouponStores.stores
            // .filter((store) => {
            //   // console.log(
            //   //   '@@499: ',
            //   //   removedStoreConditions.value,
            //   //   store.storeCategoryIds,
            //   //   store.storeCategoryIds.filter(
            //   //     (category) => category !== removedStoreConditions.value,
            //   //   ),
            //   // );
            //   return {
            //     ...store,
            //     storeCategoryIds: store.storeCategoryIds.filter(
            //       (category) => category !== removedStoreConditions.value,
            //     ),
            //   };
            // })
            .filter(
              (store) =>
                !store.storeCategoryIds.includes(removedStoreConditions.value),
            );

          if (removedStoreConditions.value === 0) {
            newCouponStores.stores = newCouponStores.stores.filter(
              (store) => !!store.storeCategoryIds.length,
            );
          }
        } else {
          newCouponStores.stores = newCouponStores.stores.filter(
            (store) =>
              removedStoreConditions.value !==
              store[`${removedStoreConditions.type}Id`],
          );

          if (removedStoreConditions.value === 0) {
            newCouponStores.stores = newCouponStores.stores.filter(
              (store) => !!store[`${removedStoreConditions.type}Id`],
            );
          }
        }

        console.log('@@513: ', newCouponStores.stores);

        Object.keys(newCouponStores)
          .filter((key) => key !== 'stores')
          .forEach((key) => {
            const groupBy = lowercaseFirstLetter(key.replace('groupBy', ''));
            if (groupBy === removedStoreConditions.type) {
              newCouponStores[key] = newCouponStores[key].filter(
                (value) => value.id !== removedStoreConditions.value,
              );
            }

            newCouponStores[key] = newCouponStores[key]
              .map((value) => ({
                ...value,
                stores:
                  groupBy === 'storeCategory'
                    ? newCouponStores.stores.filter((store) =>
                        value.id === 0
                          ? !store[`${groupBy}Ids`].length
                          : store[`${groupBy}Ids`].includes(value.id),
                      )
                    : newCouponStores.stores.filter((store) =>
                        value.id === 0
                          ? !store[`${groupBy}Id`]
                          : store[`${groupBy}Id`] === value.id,
                      ),
              }))
              .filter((value) => value.stores.length > 0);
          });

        console.log('@@513-2: ', newCouponStores);
      }

      return {
        ...state,
        couponStores: {
          ...originalCouponStores,
          ...newCouponStores,
        },
      };
    },
    loadDataFromCookie(state, { payload }) {
      const sessionStore = getObjectFromSessionStorage(storeSessionKey) || {};
      let tempStore = payload?.data ? payload?.data : {};
      console.log('@@122: session', sessionStore.description);
      console.log('@@122-2: server', tempStore.description);

      // if (!payload?.isView) {
      tempStore.name = {
        [LanguageConfig.english]: tempStore.name || null,
        [LanguageConfig.traditionalChinese]: tempStore.storeTranslations
          ? tempStore.storeTranslations[LanguageConfig.traditionalChinese]?.name
          : null,
        [LanguageConfig.simplifiedChinese]: tempStore.storeTranslations
          ? tempStore.storeTranslations[LanguageConfig.simplifiedChinese]?.name
          : null,
      };
      // console.log('@@132: ', tempStore.name, tempStore.storeTranslations);
      // console.log('@@133: ', tempStore.name);
      tempStore.address = {
        [LanguageConfig.english]: tempStore.address || null,
        [LanguageConfig.traditionalChinese]: tempStore.storeTranslations
          ? tempStore.storeTranslations[LanguageConfig.traditionalChinese]
              ?.address
          : null,
        [LanguageConfig.simplifiedChinese]: tempStore.storeTranslations
          ? tempStore.storeTranslations[LanguageConfig.simplifiedChinese]
              ?.address
          : null,
      };
      tempStore.description = {
        [LanguageConfig.english]: tempStore.description || null,
        [LanguageConfig.traditionalChinese]: tempStore.storeTranslations
          ? tempStore.storeTranslations[LanguageConfig.traditionalChinese]
              ?.description
          : null,
        [LanguageConfig.simplifiedChinese]: tempStore.storeTranslations
          ? tempStore.storeTranslations[LanguageConfig.simplifiedChinese]
              ?.description
          : null,
      };
      console.log('@@122-3: server', tempStore.description);
      // console.log(
      //   '@@128-2: ',
      //   sessionStore,
      //   removeUndefinedFieldFromDict(sessionStore),
      // );
      console.log(
        '@@122------session: ',
        sessionStore.description,
        removeUndefinedFieldFromDict(sessionStore).description,
      );
      let data = { ...tempStore };
      if (!payload?.isView) {
        data = { ...tempStore, ...removeUndefinedFieldFromDict(sessionStore) };
      }

      // console.log('@@128-3: ', data);
      // }
      console.log(
        '@@122-4: ',
        removeUndefinedFieldFromDict(sessionStore).description,
        data.description,
      );
      return {
        ...state,
        oneStore: data,
        hasUpdatedDefaultValues: true,
      };
    },
    changeVals(state, { payload }) {
      const sessionStore = getObjectFromSessionStorage(storeSessionKey) || {};
      console.log('@@122vals changed: ', payload.vals);
      let data = {};
      if (payload.vals) {
        data = payload.vals;
      }
      // console.log('@@180-1: ', sessionStore);
      // console.log('@@180-2: ', data);
      // console.log('@@180-3:', {
      //   ...sessionStore,
      //   ...removeUndefinedFieldFromDict(data),
      //   name: {
      //     ...sessionStore.name,
      //     ...removeUndefinedFieldFromDict(data.name),
      //   },
      //   address: {
      //     ...sessionStore.address,
      //     ...removeUndefinedFieldFromDict(data.address),
      //   },
      //   description: {
      //     ...sessionStore.description,
      //     ...removeUndefinedFieldFromDict(data.description),
      //   },
      // });
      let changedData = {
        ...sessionStore,
        ...removeUndefinedFieldFromDict(data),
      };

      const changedName = removeUndefinedFieldFromDict(data.name);
      if (Object.keys(changedName).length > 0) {
        console.log('@@220: ', changedName);
        changedData = {
          ...changedData,
          name: {
            ...sessionStore.name,
            ...changedName,
          },
        };
      }

      const changedAddress = removeUndefinedFieldFromDict(data.address);
      if (Object.keys(changedAddress).length > 0) {
        console.log('@@220: ', changedAddress);
        changedData = {
          ...changedData,
          address: {
            ...sessionStore.address,
            ...changedAddress,
          },
        };
      }

      const changedDescription = removeUndefinedFieldFromDict(data.description);
      if (Object.keys(changedDescription).length > 0) {
        console.log('@@220: ', changedDescription);
        changedData = {
          ...changedData,
          description: {
            ...sessionStore.description,
            ...changedDescription,
          },
        };
      }
      console.log('@@250: ', changedData, data.description, changedDescription);
      saveToSessionStorage(storeSessionKey, changedData);
      return {
        ...state,
        formChanged: true,
      };
    },
    checkValsValid(state, { payload }) {
      const sessionStore = getObjectFromSessionStorage(storeSessionKey) || {};

      const store = {
        ...state.oneStore,
        ...removeUndefinedFieldFromDict(sessionStore),
      };

      let errorFields = { fields: [], messages: [] };
      let checked = CheckStatus.initOrNotChecked;

      Object.keys(StoreErrorHandleFields).forEach((field) => {
        // eslint-disable-next-line no-useless-escape
        const emailValid =
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (['name', 'address', 'description'].includes(field)) {
          if (!store[field].en) {
            errorFields.fields.push(field);
            errorFields.messages.push({ field, errorType: 'required' });
          }
        } else if (
          field !== 'emailAddress' &&
          (!store[field] || store[field].length <= 0)
        ) {
          errorFields.fields.push(field);
          errorFields.messages.push({ field, errorType: 'required' });
        } else if (field === 'staffCode' && store[field].length !== 6) {
          errorFields.fields.push(field);
          errorFields.messages.push({ field, errorType: 'length' });
        } else if (
          field === 'emailAddress' &&
          store[field]?.length > 0 &&
          !emailValid.test(store[field])
        ) {
          // console.log('@@266: ', store[field]?.length);
          errorFields.fields.push(field);
          errorFields.messages.push({ field, errorType: 'valid' });
        }
      });

      if (errorFields.fields.length > 0) {
        checked = CheckStatus.checkedWithFail;
      } else {
        checked = CheckStatus.checkedWithSuccess;
      }
      console.log('@@errorFields: ', errorFields);
      return {
        ...state,
        checked,
        errorFields,
      };
    },
    removeFromCookie(state, { payload }) {
      removeFromSessionStorage(storeSessionKey);
      return { ...state, formChanged: false };
    },
    clearData(state, { payload }) {
      return { ...state, ...getInitState() };
    },
  },
  effects: {
    getPagedStoreWithBrand: [
      function* ({ payload }, { put, select }) {
        const { isRefresh } = payload;
        const lastCursor = yield select(
          (state) => state.storeModel.currentLastCursor,
        );
        const pageSize = 500;
        const serviceArgs = [
          getPagedSimplyStoresWithBrand,
          isRefresh ? '' : lastCursor,
          'brand',
          pageSize,
        ];
        function* onSuccess(data) {
          const pageInfo = data?.stores?.pageInfo;
          const currentLastCursor = pageInfo?.endCursor;
          const storeList = data?.stores?.edges.map((item) => ({
            pk: item.node.pk,
            title: `[${item.node.pk}]${item.node.name}${item.node.visibleInFrontEnd ? '' : ' (closed)'}`,
            name: item.node.name,
            address: item.node.address,
            brandGroupKey: item.node.brand
              ? {
                  pk: item.node.brand.pk,
                  name: item.node.brand?.name || '-',
                }
              : {
                  pk: 'Stores without brand',
                  name: 'Stores without brand',
                },
          }));
          const stateStoreList = yield select(
            (state) => state.storeModel.pagedStoreList,
          );
          yield put({
            type: 'updateState',
            payload:
              isRefresh || !stateStoreList
                ? {
                    pagedStoreList: storeList,
                    currentLastCursor,
                  }
                : {
                    pagedStoreList: [...stateStoreList, ...storeList],
                    currentLastCursor,
                  },
          });
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    getPagedStoreList: [
      function* ({ payload }, { put, select }) {
        const page = payload.page || 1;
        const pageCursor = payload.page
          ? convertNumberToCursor((page - 1) * 20 - 1)
          : '';
        const serviceArgs = [getPagedStores, pageCursor, payload];
        function* onSuccess(data) {
          const pageInfo = data?.stores?.pageInfo;
          const currentLastCursor = pageInfo?.endCursor;
          const totalCount = data?.stores?.totalCount;

          const storeList = data?.stores?.edges.map((item) =>
            parseListStore(item.node),
          );
          if (payload.isSelectorLoad) {
            const stateStoreList = yield select(
              (state) => state.storeModel.storeList,
            );
            yield put({
              type: 'updateState',
              payload: {
                storeList:
                  page > 1 ? [...stateStoreList, ...storeList] : storeList,
              },
            });
          } else {
            yield put({
              type: 'updateState',
              payload: {
                pagedStoreList: storeList,
                pageInfo: {
                  startCursor: convertCursorToNumber(pageInfo.startCursor) + 1,
                  endCursor: convertCursorToNumber(pageInfo.endCursor) + 1,
                },
                currentLastCursor,
                totalCount,
                totalPage: Math.ceil(totalCount / 20),
              },
            });
          }
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    getAllPureStores: [
      function* ({ payload }, { put, select }) {
        yield put({ type: 'updateState', payload: { allListLoading: true } });
        const serviceArgs = [getPureStores];
        function* onSuccess(data) {
          const pureStore = data?.pureStores || [];
          const storeList = pureStore.map((item) => parseStore(item, true));
          yield put({
            type: 'updateState',
            payload: {
              pureStores: storeList,
              totalCount: pureStore.length,
              allListLoading: false,
            },
          });
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    doStoreRequest: [
      function* ({ payload }, { put }) {
        yield put({ type: 'updateState', payload: { allListLoading: true } });
        const newPayload = {
          ...payload,
          pageSize: 100,
          minimalist: true,
          isSelectorLoad: true,
        };
        console.log('doStoreRequest:', payload);
        const notBrandRelate = payload.notBrandRelate;

        yield put({
          type: 'updateState',
          payload: notBrandRelate
            ? { appliableStoreList: [] }
            : { brandStoreList: [] },
        });
        yield put({
          type: notBrandRelate ? 'getAppliableStores' : 'getBrandStores',
          payload: newPayload,
        });
      },
      { type: 'takeLatest' },
    ],

    getBrandStores: [
      function* ({ payload }, { put, select }) {
        yield brandApplicableStore(payload, select, put);
      },
      { type: 'takeLatest' },
    ],

    getAppliableStores: [
      function* ({ payload }, { put, select }) {
        yield brandApplicableStore(payload, select, put);
      },
      { type: 'takeLatest' },
    ],
    getAllCouponStores: [
      function* ({ payload }, { put, select }) {
        const serviceArgs = [getAllCouponStores, payload];

        // eslint-disable-next-line require-yield
        function* onSuccess(data) {
          const stores = data?.filterStores?.stores;
          const nonBrandStores = stores.filter((s) => !s.brandId);
          const groupByBrand = (data?.filterStores?.brands || []).map(
            (brand) => {
              return {
                ...brand,
                stores: stores.filter((s) => s.brandId === brand.id),
              };
            },
          );
          if (nonBrandStores?.length) {
            groupByBrand.push({
              id: 0,
              name: 'No related brand',
              stores: nonBrandStores,
            });
          }

          const nonMallStores = stores.filter((s) => !s.mallId);
          const groupByMall = (data?.filterStores?.malls || []).map((mall) => {
            return {
              ...mall,
              stores: stores.filter((s) => s.mallId === mall.id),
            };
          });
          if (nonMallStores?.length) {
            groupByMall.push({
              id: 0,
              name: 'No related mall',
              stores: nonMallStores,
            });
          }

          const nonCategoryStores = stores.filter(
            (s) => !s.storeCategoryIds?.length,
          );
          let groupByStoreCategory = (
            data?.filterStores?.storeCategories || []
          ).map((category) => {
            return {
              ...category,
              stores: stores.filter((s) =>
                s.storeCategoryIds.includes(category.id),
              ),
            };
          });
          if (payload.storeCategoryIds) {
            groupByStoreCategory = groupByStoreCategory.filter((category) =>
              payload.storeCategoryIds?.includes(category.id),
            );
          }
          if (nonCategoryStores?.length) {
            groupByStoreCategory.push({
              id: 0,
              name: 'No related store category',
              stores: nonCategoryStores,
            });
          }

          yield put({
            type: 'updateState',
            payload: {
              couponStores: {
                stores,
                groupByBrand,
                groupByMall,
                groupByStoreCategory,
              },
            },
          });
        }
        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],

    delete: [
      function* ({ payload }, { select, put, all }) {
        const { checkedSegments } = yield select((state) => ({
          checkedSegments: state.storeModel.checkedList,
        }));

        let pks = [];
        checkedSegments.forEach((item) => {
          pks.push(item.pk);
        });

        const serviceArgs = [deleteStores, pks];
        const afterAction = payload.afterAction || (() => {});
        function* onSuccess(data) {
          console.log('@@153: ', data);
          yield all([
            put({
              type: 'storeModel/updateState',
              payload: { checkedList: [] },
            }),
          ]);

          afterAction();
        }

        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    getOneStore: [
      function* ({ payload }, { call, select, put }) {
        const serviceArgs = [
          getOneStore,
          convertPKToId('StoreNode', payload.id),
        ];
        function* onSuccess(data) {
          const store = parseStore(data.store);
          yield put({
            type: 'updateState',
            payload: {
              oneStore: store,
              isView: payload.view || false,
            },
          });
          const action = payload?.afterAction || (() => {});
          yield action(store);
        }

        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    createOrUpdate: [
      function* ({ payload }, { call, select, put }) {
        let data = payload.data;
        // let source = {};
        console.log('@534', payload, data);
        if (!data) {
          return;
        }

        yield put({
          type: 'updateState',
          payload: { saved: APIStatus.calling },
        });
        const oldData = yield select((state) => state.storeModel.oneStore);
        const source = postData(data, oldData);
        const afterAction = payload.afterAction || (() => {});
        const serviceArgs = [createOrUpdateStore, source];
        function* onSuccess(data) {
          if (
            ('createStore' in data && data.createStore.errors) ||
            ('updateStore' in data && data.updateStore.errors)
          ) {
            yield put({
              type: 'updateState',
              payload: {
                saved: APIStatus.failed,
                formChanged: false,
                checked: CheckStatus.initOrNotChecked,
              },
            });
          } else {
            const updateData = {
              formChanged: false,
              saved: APIStatus.success,
              checked: CheckStatus.initOrNotChecked,
              formHasSubmitted: true,
            };
            if (data.createStore?.node?.pk) {
              updateData.oneStore = {
                storePK: data.createStore?.node?.pk,
                isOnlineStore: data.createStore?.node?.isOnlineStore,
              };
            }
            yield put({
              type: 'updateState',
              payload: updateData,
            });

            removeFromSessionStorage(storeSessionKey);
          }

          afterAction();
        }

        function* onFail(data) {
          yield put({
            type: 'updateState',
            payload: {
              formChanged: false,
              saved: APIStatus.failed,
              // formHasSubmitted: true,
              // hasUpdatedDefaultValues: true,
            },
          });
        }

        yield apiWithResponseHandle(serviceArgs, onSuccess, onFail, onFail);
      },
      { type: 'takeLatest' },
    ],
    duplicate: [
      function* ({ payload }, { call, select, put }) {
        const duplicateData = payload?.data;
        function* storeGet(store) {
          console.log('@735 store', store);
          const newStore = {
            ...store,
            storeTranslations: {
              ...store.storeTranslations,
              en: {
                ...store.storeTranslations.en,
                name: `Copy of ${store.name}`,
              },
            },
            pk: null,
            storePK: null,
          };
          yield put(
            createAction('createOrUpdate')({
              data: newStore,
              afterAction: payload.afterAction,
            }),
          );
        }
        yield put({
          type: 'getOneStore',
          payload: { id: duplicateData?.pk, afterAction: storeGet },
        });
      },
      { type: 'takeLatest' },
    ],
    getDistrictList: [
      function* ({ payload }, { select, put }) {
        const page = payload.page || 1;
        const pageCursor = payload.page
          ? convertNumberToCursor((page - 1) * 50 - 1)
          : '';
        const serviceArgs = [getDistricts, pageCursor, payload];
        function* onSuccess(data) {
          const districtList = data?.districts?.edges.map((item) => item.node);
          if (payload.isSelectorLoad) {
            const { stateDistrictList } = yield select((state) => ({
              stateDistrictList: state.storeModel?.districtList,
            }));
            yield put({
              type: 'updateState',
              payload: {
                districtList:
                  page > 1
                    ? [...stateDistrictList, ...districtList]
                    : districtList,
              },
            });
          } else {
            yield put({
              type: 'updateState',
              payload: {
                districtList: districtList,
              },
            });
          }
        }
        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    downloadStoreCodes: [
      function* ({ payload }, { select }) {
        const { checkedSegments } = yield select((state) => ({
          checkedSegments: state.storeModel.checkedList,
        }));
        const pks = [];
        checkedSegments.forEach((item) => {
          pks.push(item.pk);
        });
        const serviceArgs = [getDownloadStoreCodesZip, { ids: pks }];

        // eslint-disable-next-line require-yield
        function* onSuccess(data) {
          const link = data?.downloadStores?.zipLink;
          downloadZipFiles(link);
        }
        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
  },
});